import { Modal } from "antd";
import styled from "styled-components";
import { MdToday } from "react-icons/md";
import useModalSchedule from "../../../../hooks/useModalSchedule";

type Props = {
  pdfUrl: any;
};

function ModalExportPdf({ pdfUrl }: Props) {
  const { isOpenPdf, setIsOpenPdf } = useModalSchedule();

  function closedModal() {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    setIsOpenPdf(false);
  }

  return (
    <CustomModal
      title={
        <Header>
          <MdToday size={20} />
          Detalhes do exportação
        </Header>
      }
      visible={isOpenPdf}
      width={"95%"}
      onCancel={closedModal}
      maskClosable={false}
      destroyOnClose
      centered
      getContainer={document.body}
      footer={null}
    >
      <div>
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            title="pdf"
            width="100%"
            height="600px"
            style={{ border: "none" }}
          />
        )}
      </div>
    </CustomModal>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const CustomModal = styled(Modal)`
  position: relative;
  /* height: 90%; */
  /* max-height: 90vh; */
  max-height: 100vh;

  .ant-modal-content {
    border-radius: 10px;
    height: 100%;
    
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  td .ant-form-item {
    margin-bottom: 0;
  }

  td .ant-form-item-with-help .ant-form-item-explain {
    display: none;
  }

  td input[type=number], td input[type=date] {
    height: 2.4rem;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    max-height: calc(100vh - 122px);
    height: auto;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    overflow: hidden;
  }

  .ant-modal-footer {
    height: 61px;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

export default ModalExportPdf;
